import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, Modal, DatePicker } from "antd";
import axios from "axios";
import "./Pages.css";
import CarteiraClientesPrintModal from "../relatorios/CarteiraClientesPrintModal";
import PessoaFrame from '../components/PessoaFrame';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario } from "../utils/LoginManager";
import { maskDate } from "../utils/Masker";
import Colors from '../utils/Colors';

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    qtdeVendas: 0,
    vendasTotais: 0,
    ticketMedio: 0,
    totalRecebido: 0,
    totalReceber: 0,
    totalRecVenc: 0,

    filtros: {
      tipoTela: 'CC',
      buscaOrdem: { campo: 'pes_nome', ordem: 'ASC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0' },
      buscaProduto: { key: '0' },
      buscaGrupoProduto: { key: '0' },
      buscaMarcaProduto: { key: '0' },
      buscaServico: { key: '0' },
      buscaUsuario: { key: '0' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }


  getListaRegistros = () => {
    this.setState({
      listaRegistros: [], carregando: true,
      qtdeVendas: 0, vendasTotais: 0, ticketMedio: 0, totalRecebido: 0, totalReceber: 0, totalRecVenc: 0
    });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaPessoa, buscaOrdem } = this.state.filtros;

    if ((buscaDataIni) && (buscaDataFim)) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/vendas/listaCarteiraCliente', {
          params: {
            page: pagina,
            limite: limite,
            campoOrdem: buscaOrdem.campo,
            tipoOrdem: buscaOrdem.ordem,
            pessoa: buscaPessoa.key,
            dataIni,
            dataFim,
          }
        })
        .then(response => {
          const { data, total, current_page, per_page } = response.data.dados;
          this.setState({
            listaRegistros: data,
            carregando: false,
            total: total,
            pagina: current_page,
            limite: Number(per_page),

            qtdeVendas: response.data.qtdeVendas ? response.data.qtdeVendas : 0,
            vendasTotais: response.data.vendasTotais ? response.data.vendasTotais : 0,
            ticketMedio: response.data.ticketMedio ? response.data.ticketMedio : 0,

            totalRecebido: response.data.totalRecebido ? response.data.totalRecebido : 0,
            totalReceber: response.data.totalReceber ? response.data.totalReceber : 0,
            totalRecVenc: response.data.totalRecVenc ? response.data.totalRecVenc : 0,
          });

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };


  onChangePessoa = event => {
    const { filtros } = this.state;
    filtros['buscaPessoa'] = event.buscaPessoa;
    this.setState(
      event,
      this.getListaRegistros
    );
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value
    },
      this.getListaRegistros
    );
  };

  onChangePeriodo = event => {
    const { filtros } = this.state;
    if (event[0]) {
      filtros.buscaDataIni = moment(event[0]._d).format('DD/MM/YYYY');
      filtros.buscaDataFim = moment(event[1]._d).format('DD/MM/YYYY');
    } else {
      filtros.buscaDataIni = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY');
      filtros.buscaDataFim = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY');
    }
    this.setState({
      filtros
    },
      this.getListaRegistros
    );
  };




  renderData = (data, registro) => {
    // const dataMoment = moment(registro.ultVenda);
    let dataMoment = '';
    if ((registro.ultVenda) && (registro.ultOS)) {
      if (moment(registro.ultVenda) > moment(registro.ultOS)) {
        dataMoment = moment(registro.ultVenda);
      } else {
        dataMoment = moment(registro.ultOS);
      }
    } else if (registro.ultVenda) {
      dataMoment = moment(registro.ultVenda);
    } else if (registro.ultOS) {
      dataMoment = moment(registro.ultOS);
    }
    return (
      <span>
        {dataMoment ? dataMoment.format('DD/MM/YYYY') : ''}
      </span>
    )
  }


  renderAcoes = (text, registro) => {
    return (
      <Tooltip title="Visualizar">
        <Button type="ghost" size="small" onClick={() => this.onVisualizarClick(registro)} icon="eye-o" />
      </Tooltip>
    );
  };

  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(vlr).format('0,000.00')} </span>
    );
  };

  renderValorVendasTotais = (vlr, registro) => {
    const vlrVendas = registro && registro.vendasTotais ? parseFloat(registro.vendasTotais) : 0;
    const vlrOS = registro && registro.vendasOSTotais ? parseFloat(registro.vendasOSTotais) : 0;
    return (
      <span> {numeral(vlrVendas + vlrOS).format('0,000.00')} </span>
    );
  };

  renderPercVendas = (vlr, registro) => {
    const vlrVendas = registro && registro.vendasTotais ? parseFloat(registro.vendasTotais) : 0;
    const vlrOS = registro && registro.vendasOSTotais ? parseFloat(registro.vendasOSTotais) : 0;
    return (
      <span> {numeral(parseFloat(((vlrVendas + vlrOS) * 100) / this.state.vendasTotais)).format('0,000.00')} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, filtros, total, pagina, limite, } = this.state;
    const { buscaDataIni, buscaDataFim, buscaPessoa } = this.state.filtros;

    // console.log('CaixasPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Carteira de Clientes</span>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 20 }}>
            <Col xs={24} >

              <Row xs={24} style={{}}>
                <Col xs={6} style={{ marginRight: 10 }}>
                  <span>Período</span>
                  <RangePicker
                    style={{ width: "100%" }}
                    masker={maskDate}
                    value={[moment(buscaDataIni, dateFormat), moment(buscaDataFim, dateFormat)]}
                    format={dateFormat}
                    allowClear={false}
                    onChange={this.onChangePeriodo}
                  />
                </Col>

                <Col xs={6} style={{ width: 420, marginTop: -4, marginRight: 10 }}>
                  <PessoaFrame
                    label="Cliente"
                    id="buscaPessoa"
                    value={buscaPessoa}
                    width={"100%"}
                    tipo="C"
                    onChange={this.onChangePessoa}
                  />
                </Col>

                <Col xs={2} style={{ width: 110, marginTop: 20 }}>
                  <CarteiraClientesPrintModal
                    filtros={filtros}
                    qtdeVendas={this.state.qtdeVendas}
                    vendasTotais={this.state.vendasTotais}
                    ticketMedio={this.state.ticketMedio}
                    totalRecebido={this.state.totalRecebido}
                    totalReceber={this.state.totalReceber}
                    totalRecVenc={this.state.totalRecVenc}
                    pessoa={this.state.filtros.buscaPessoa}
                    periodo={this.state.filtros.buscaDataIni + ' a ' + this.state.filtros.buscaDataFim}
                  />
                </Col>


              </Row>


              <Row>
                <Col xs={24} md={24} style={{ height: 65, padding: 5, marginTop: -30 }}>
                  <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          Qtde Vendas
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeVendas}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          Vendas Totais
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vendasTotais)}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          Ticket Médio
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.ticketMedio)}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          Recebido
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalRecebido)}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          À Receber
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalReceber)}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          Vencido
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalRecVenc)}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                </Col>
                {/* <Col xs={24} sm={24} style={{ background: Colors.background, padding: 5, marginTop: -15 }}>
                  <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Qtde Vendas</span></Row>
                    <Row><span>{this.state.qtdeVendas}</span></Row>
                  </Col>
                  <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Vendas Totais</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.vendasTotais)}</span></Row>
                  </Col>
                  <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Ticket Médio</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.ticketMedio)}</span></Row>
                  </Col>
                  <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Recebido</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.totalRecebido)}</span></Row>
                  </Col>
                  <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>À Receber</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.totalReceber)}</span></Row>
                  </Col>
                  <Col xs={24} sm={3} style={{ textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Vencido</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.totalRecVenc)}</span></Row>
                  </Col>
                </Col> */}
              </Row>

            </Col>

          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.pes_codigo)}
            >
              <Column
                key="pes_codigo"
                dataIndex="pes_codigo"
                title={this.renderTitulo("Cliente")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={70}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pes_nome"
                dataIndex="pes_nome"
                title={this.renderTitulo("Nome Cliente")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={200}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="ultVenda"
                dataIndex="ultVenda"
                title={this.renderTitulo("Últ. Venda")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderData}
                width={100}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="qtdeVendas"
                dataIndex="qtdeVendas"
                title={this.renderTitulo("Qtde Vendas")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vendasTotais"
                dataIndex="vendasTotais"
                title={this.renderTitulo("Vendas Totais")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValorVendasTotais}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vendasTotais1"
                dataIndex="vendasTotais1"
                title={this.renderTitulo("% nas Vendas")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderPercVendas}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="ticketMedio"
                dataIndex="ticketMedio"
                title={this.renderTitulo("Ticket Médio")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="totalRecebido"
                dataIndex="totalRecebido"
                title={this.renderTitulo("Recebido")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="totalReceber"
                dataIndex="totalReceber"
                title={this.renderTitulo("À Receber")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="totalRecVenc"
                dataIndex="totalRecVenc"
                title={this.renderTitulo("Em Atraso")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/CarteiraClientesPage.js